import { clone } from "@tm/utils"

export function removeFields<T, K extends keyof T>(object: T, ...args: K[]) {
    const clonedObj = clone(object)
    args.forEach((key) => delete clonedObj[key])
    return clonedObj
}
